import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('payment_run_bills'),
    billColumn: defineMessage('bill'),
    dueDateColumn: defineMessage('due_date'),
    amountColumn: defineMessage('amount'),
    amountDueColumn: defineMessage('amount_due'),
    paymentDetailsColumn: defineMessage('payment_details'),
    refColumn: defineMessage('ref'),
    paymentStatusColumn: defineMessage('payment_status'),
    attachmentColumn: defineMessage('attach'),
    xeroLink: defineMessage('xero_link'),
    openInXero: defineMessage('open_in_xero'),
    total: defineMessage('total'),
    totalPaid: defineMessage('total_paid'),
    remaining: defineMessage('remaining'),
    paymentDetailsChanged: defineMessage('payment_details_have_changed'),
    billsTotalName: defineMessage('bills_from_contactname'),
};
